declare const $;
export function closeOnBlur_Directive() {
  var directive = {
    link: link,
    restrict: 'A',
    scope: {
        showResult: '=',
    }
  };
  return directive;

  function link(
    scope: any,
    element: ng.IRootElementService,
    attrs: ng.IAttributes
  ) {
    $(element).on('focus', () => {
      setTimeout(() => {
        $(document).on('click', (event: any) => {
            console.log(element);
        const condition = event.target === element[0] || event.target.localName === 'li';
          if (!condition) {
            scope.showResult = false;
            scope.$apply();
            $(document).off('click');
          }
        });
      }, 100);
    });
  }
}



// WEBPACK FOOTER //
// ./src/store-modules/management/close-on-blur.directive.ts